import {usePermissions} from 'react-admin'

const useIsSuperAdmin = () => {
  const {permissions: {allowedRoles = []} = {}} = usePermissions<Permissions>()
  return allowedRoles.includes('super_admin')
}

export default useIsSuperAdmin
